/**
 * 게시물 정렬 유틸리티 함수
 * isPublic 속성을 기준으로 게시물을 정렬합니다.
 */

/**
 * 게시물 배열을 공개 상태(isPublic) 기준으로 정렬하는 함수
 * isPublic 값이 큰 것(공개된 게시물)을 먼저 표시합니다.
 *
 * @param {Array} items - 정렬할 게시물 배열
 * @returns {Array} isPublic 기준 내림차순 정렬된 배열
 *
 * @example
 * const items = [
 *   { id: 1, title: "게시물1", isPublic: 0 },
 *   { id: 2, title: "게시물2", isPublic: 1 }
 * ];
 * const sorted = Sort(items); // isPublic=1인 게시물이 먼저 옴
 */
export function Sort(items) {
  // isPublic 값 기준 내림차순 정렬 (1이 먼저, 0이 나중)
  items.sort((a, b) => b.isPublic - a.isPublic);

  return items;
}
